import React from 'react'
import { NextPage } from 'next'
import { PagePropsWrapper, SEOFriendlyInitialProps } from 'lib/routing/nextPageUtils'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { DedicatedDebtCalculatorPage } from 'experiences/Calculators'
import { ArticleSummary, summarizeArticles } from 'services/ContentfulService/models/articles'
import { NamedPromises } from 'lib'
import { fetchArticles } from 'services/ContentfulService/hooks/articles'
import {
	OrderByNewestConstraint,
	ProductConstraint,
	TopicProductConstraint
} from 'services/ContentfulService/constraints'
import { Topic, TopicTypeSorter } from 'services/ContentfulService/models/topics'
import { ContentfulHookProps } from 'services/ContentfulService/hooks/template'
import { getTopics } from 'services/ContentfulService/hooks/topics'
import { ContentfulProducts } from 'parameters/products'

interface Props {
	topics: Topic[]
	articles: ArticleSummary[]
}

const DebtCalculator: NextPage<PagePropsWrapper<Props>> = ({ metaTags, pageProps }) => {
	return (
		<StandardLayout metaTags={metaTags}>
			<DedicatedDebtCalculatorPage topics={pageProps.topics} articles={pageProps.articles} />
		</StandardLayout>
	)
}

const topicsInput: ContentfulHookProps = { constraints: [TopicProductConstraint(ContentfulProducts.Loans)], count: 4 }
const articlesInput: ContentfulHookProps = {
	constraints: [ProductConstraint(ContentfulProducts.Loans), OrderByNewestConstraint()],
	count: 4
}

DebtCalculator.getInitialProps = SEOFriendlyInitialProps<Props>(
	async () => {
		return await NamedPromises({
			topics: getTopics(topicsInput).then(topics => topics.sort(TopicTypeSorter)),
			articles: fetchArticles(articlesInput).then(summarizeArticles)
		})
	},
	metadataTags => {
		return {
			...metadataTags,
			title: 'Debt Consolidation Calculator',
			description:
				'Our debt consolidation calculator lets you enter your current outstanding debt, average interest and monthly payment, then finds offers on our network to see how much you could save each month by taking out a personal loan.'
		}
	}
)

export default DebtCalculator
